'use strict';

var React = require('react');

var SvgKeyboardMajor = function SvgKeyboardMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1 6.85c0-.746.604-1.35 1.35-1.35h15.3c.745 0 1.35.604 1.35 1.35v6.3a1.35 1.35 0 0 1-1.35 1.35h-15.3a1.35 1.35 0 0 1-1.35-1.35v-6.3Zm2.7.45h1.8v1.8h-1.8v-1.8Zm.9 3.6v1.8h1.8v-1.8h-1.8Zm7.2 1.8h-3.6v-1.8h3.6v1.8Zm-2.7-5.4h-1.8v1.8h1.8v-1.8Zm3.6 0h-1.8v1.8h1.8v-1.8Zm3.6 0h-1.8v1.8h1.8v-1.8Zm-.9 5.4v-1.8h-1.8v1.8h1.8Z"
  }));
};

exports.SvgKeyboardMajor = SvgKeyboardMajor;
